import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Output, EventEmitter, Input } from '@angular/core';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
@Component({
  selector: 'app-project-type',
  templateUrl: './project-type.component.html',
  styleUrls: ['./project-type.component.css'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
})
export class ProjectTypeComponent implements OnInit, OnChanges {
  @Input() projectType: any;
  @Input() projectSubType: any;
  @Input() projectTypeId: any;
  @Output() changeProjectType: EventEmitter<string> =
    new EventEmitter<string>();
  @Output() changeProjectSubType: EventEmitter<string> =
    new EventEmitter<string>();
  @Output() customeTypeData: EventEmitter<any> = new EventEmitter<any>();
  selectedType: any;
  customType: any;
  customParent: any;
  updatedCustomProjectType: any;
  projectTypeControl = new FormControl('');
  parants: any = [];
  childs: any = [];
  selectedTypeId: any;
  form: FormGroup;
  constructor(
    private projectsService: ProjectsService,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      customType: [''],
    });
    this.form.get('customType')?.valueChanges.subscribe((value) => {
      this.customType = value;
      this.onCustomTypeChange(value);
    });
  }
  ngOnInit() {
    this.getProjectTypes();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectTypeId'] && changes['projectTypeId'].currentValue) {
      const newProjectTypeId = changes['projectTypeId'].currentValue;
      this.getProjectSubTypes(newProjectTypeId);
    }
  }

  onCustomTypeChange(newValue: string): void {
    this.customeTypeData.emit({
      customParentName: this.customParent,
      CustomProjectTypeParentId: this.updatedCustomProjectType,
      customType: newValue,
    });
  }

  updateCustomType(value: string) {
    this.form.get('customType')?.setValue(value);
  }

  getProjectTypes() {
    this.projectsService.getAllProjectTypes().subscribe({
      next: (response: any) => {
        this.parants.push(response.data);
        this.parants[0].push({ name: 'Custom', id: 'custom' });
      },
      error: (error: any) => {
        console.error('Error fetching the project types:', error);
      },
    });
  }
  getProjectSubTypes(id: any) {
    if (id === undefined) return;
    this.projectsService.getAllProjectSubTypes(id).subscribe({
      next: (response: any) => {
        if (response.data) {
          this.childs.push(response.data);
        } else {
          this.changeProjectSubType.emit(response.data);
        }
      },
      error: (error: any) => {
        console.error('Error fetching the project types:', error);
      },
    });
  }
  onSelectionMainProjectType(option: any, id: any) {
    this.changeProjectType.emit(id);
    this.selectedType = option;
    this.selectedTypeId = id;
    this.childs = [];
    if (this.projectType !== 'Custom') {
      this.getProjectSubTypes(id);
    }
  }
  onSelectionCustomParent(option: any, id: any) {
    if (id !== 'Custom') {
      this.updatedCustomProjectType = id;
      this.onCustomTypeChange(this.customType);
    } else {
      this.updatedCustomProjectType = 'Custom';
      this.onCustomTypeChange(this.customType);
    }

    this.customParent = option;
    this.childs = [];
  }

  onSelectionSubProjectType(option: string, id: any) {
    this.changeProjectSubType.emit(id);
    this.projectSubType = option;
  }
}
